import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { usePortal } from 'components/portal/portal';
import { AdminUsers } from './AdminUsers';
import { zx } from 'shared/type';
import { useElementSize } from 'shared/ui';
import { AdminWorkspace } from './AdminWorkspace';
import { Workspace as W } from '../workspace';
import { useQueryString } from 'utils/useQueryString';
import { z } from 'zod';
import { HiCollection, HiUser, HiCreditCard, HiCash } from 'react-icons/hi';
import { FaHandSpock } from 'react-icons/fa';
import { ForecasterParticipation } from './AdminParticipation';
import { AdminSubscription } from './AdminSubscription';
import { match } from 'ts-pattern';
import { AdminSubscriptionsGlobal } from './AdminSubscriptionsGlobal';
import { AppTitle } from '../Title';
export const adminTabMd = {
  users: {
    label: 'Users',
    Icon: HiUser
  },
  workspace: {
    label: 'Workspace',
    Icon: HiCollection
  },
  'forecaster-participation': {
    label: 'Forecaster Participation',
    Icon: FaHandSpock
  },
  subscription: {
    label: 'Subscription',
    Icon: HiCreditCard
  },
  'global-subscriptions': {
    label: 'Global Subscriptions',
    Icon: HiCash
  }
} satisfies Record<string, {
  label: string;
  Icon: any;
}>;
type Tab = keyof typeof adminTabMd;
const zQs = z.object({
  tab: zx.enumFromObjKeys(adminTabMd).optional()
});
export const Admin = () => {
  const $ = _c(16);
  const {
    profile,
    profiles
  } = usePortal();
  const router = useRouter();
  const {
    ref
  } = useElementSize();
  const {
    query
  } = useQueryString(zQs);
  const tab = query?.tab ?? "users";
  let t0;
  if ($[0] !== profiles?.global) {
    t0 = profiles?.global?.hasRole("admin");
    $[0] = profiles?.global;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isGlobalAdmin = t0;
  const uWorkspace = W.useAdminWorkspace();
  let t1;
  if ($[2] !== isGlobalAdmin) {
    t1 = {
      enabled: isGlobalAdmin
    };
    $[2] = isGlobalAdmin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const uWorkspaceGlobal = W.useAdminWorkspaceGlobal(t1);
  if (profile != null && !profile.hasPermission("settings")) {
    if (router.isReady) {
      router.push("/");
    }
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t2 = `${adminTabMd[tab].label}`;
  let t3;
  if ($[5] !== t2) {
    t3 = <AppTitle title={t2} />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== profile || $[8] !== tab || $[9] !== uWorkspace || $[10] !== uWorkspaceGlobal) {
    t4 = profile != null && <div className="h-full w-full overflow-y-scroll pb-[10em]">{match(tab).with("users", () => <AdminUsers uWorkspace={uWorkspace} />).with("workspace", () => <AdminWorkspace uWorkspace={uWorkspace} uWorkspaceGlobal={uWorkspaceGlobal} className="md:px-4" />).with("forecaster-participation", _temp).with("subscription", _temp2).with("global-subscriptions", _temp3).exhaustive()}</div>;
    $[7] = profile;
    $[8] = tab;
    $[9] = uWorkspace;
    $[10] = uWorkspaceGlobal;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== ref || $[13] !== t3 || $[14] !== t4) {
    t5 = <div ref={ref} className="@container w-full">{t3}{t4}</div>;
    $[12] = ref;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp() {
  return <ForecasterParticipation />;
}
function _temp2() {
  return <AdminSubscription />;
}
function _temp3() {
  return <AdminSubscriptionsGlobal />;
}